import React from "react";
import { ArrowLeft } from "react-feather";
import { Link, useNavigate } from "react-router";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <button
      className="border  border-gray-400 p-1 rounded-full"
      onClick={() => navigate(-1)}
    >
      <ArrowLeft />
    </button>
  );
};

export default BackButton;
